import React from 'react'
import { TabItemProps } from './TabItem.types'

const TabItem: React.FC<TabItemProps> = ({
  label,
  active = false,
  onClick,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-4 h-10 rounded-md text-sm font-medium transition cursor-pointer
        ${
          active
            ? 'active-gradient text-[var(--tab-text-active)] font-semibold'
            : 'bg-[var(--tab-bg)] border border-[var(--tab-btn-border)] text-[var(--tab-text)] hover:bg-[var(--bet-type-hover-bg)] hover:text-[var(--bet-type-hover-text)] hover:border-[var(--bet-type-hover-border)]'
        }`}
    >
      {label}
    </button>
  )
}

export default TabItem
